// Tipos da tela de Visão Detalhada de BESS (SGD-3676).
// Espelha o BessChartSeries retornado pelo main-api (/api/bess/{equipmentId}/soc|power).

export interface BessChartSeries {
    dataTypeId: number;
    dataTypeName: string;
    teleObjectId: number;
    teleObjectConfigName: string;
    equipmentName: string;
    unit: string;
    dateTime: string[];
    value: number[];
}

export interface BessChartResponse {
    message: string;
    data: Array<BessChartSeries>;
}

// Códigos de tele_object_data_type (ver SGD-3676 / backend BessResource)
export const BESS_DATA_TYPE = {
    SOC: 47,
    ACTIVE_POWER: 5,
    REACTIVE_POWER: 8,
} as const;
